import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const ColorFilters = ({ filters, onFilterChange, onReset }) => {
  const groupOptions = [
    { value: '', label: 'All Groups' },
    { value: 'base-colors', label: 'Base Colors' },
    { value: 'flake-colors', label: 'Flake Colors' },
    { value: 'metallic', label: 'Metallic' },
    { value: 'seasonal', label: 'Seasonal' },
    { value: 'popular', label: 'Popular' },
    { value: 'custom', label: 'Custom' }
  ];

  const sortOptions = [
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'usage-desc', label: 'Most Used' },
    { value: 'usage-asc', label: 'Least Used' },
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' }
  ];

  const hasActiveFilters = filters?.search || filters?.group || filters?.sortBy !== 'name-asc';

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search colors by name or hex code..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <div className="w-full sm:w-48">
            <Select
              options={groupOptions}
              value={filters?.group}
              onChange={(value) => onFilterChange('group', value)}
              placeholder="Filter by group"
            />
          </div>

          <div className="w-full sm:w-48">
            <Select
              options={sortOptions}
              value={filters?.sortBy}
              onChange={(value) => onFilterChange('sortBy', value)}
              placeholder="Sort by"
            />
          </div>

          {hasActiveFilters && (
            <Button
              variant="outline"
              onClick={onReset}
              iconName="X"
              iconPosition="left"
              iconSize={14}
            >
              Reset
            </Button>
          )}
        </div>
      </div>
      <div className="flex items-center gap-4 mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-text-secondary">
          <Icon name="Info" size={16} />
          <span>
            Showing colors that customers can select in the visualizer
          </span>
        </div>
      </div>
    </div>
  );
};

export default ColorFilters;